import React, { ReactNode } from 'react';
import Modal, { ModalProps } from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const getDefaultModalStyle = (isMobile: boolean): SxProps<Theme> => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: isMobile ? '90%' : 400,
  maxWidth: isMobile ? '100%' : 600,
  maxHeight: isMobile ? '90vh' : '80vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: isMobile ? 2 : 5,
  p: isMobile ? 2 : 4,
});

interface GlobalModalProps extends Omit<ModalProps, 'children' | 'style'> {
  modalTitle: string;
  modalDescription: string;
  style?: SxProps<Theme>;
  children?: ReactNode;
  open: boolean;
  onClose: () => void;
}

// Accessibility: aria-labelledby and aria-describedby are required for all modals for screen reader support.
export const GlobalModal: React.FC<GlobalModalProps> = (props) => {
  const { modalTitle, modalDescription, style, children, ...rest } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const defaultStyle = getDefaultModalStyle(isMobile);
  const modalStyle = style ? { ...defaultStyle, ...style } : defaultStyle;

  return (
    <Modal
      aria-labelledby={modalTitle}
      aria-describedby={modalDescription}
      {...rest}
    >
      <Box sx={modalStyle}>
        {children}
      </Box>
    </Modal>
  );
}; 